export const AD_ITERVAL = 5;

export const MOBILE_AD_ITERVAL = 3;
